import React, { useState, useEffect } from "react";
import Chessboard from "chessboardjsx";
import firebase from "firebase";

import "./style/style.css";

import Navbar from "./Nav";
import MovesBox from "./Moves";
import ScoreBox from "./Score";
import useWindowSize from "./WindowSize.jsx";
import SelectFEN from "./Select";

import { useDispatch, useSelector } from "react-redux";
import { POSITION_CHANGED } from "../store/reducerBoardPosition.js";

/* 
export function fenExoport(chesspuzzleFEN = [], selectOption = 0) {
  return chesspuzzleFEN[selectOption].Fen;
}
 */

function MainMenu() {
  const [chesspuzzleFEN, setChesspuzzleFEN] = useState([]);
  const [selectOption, setSelectOption] = useState(1);
  const [point, setPoint] = useState([]);
  const dispatch = useDispatch();
  const moves = useSelector((state) => state.reducerBoardPosition.position);
  const userID = firebase.auth().currentUser;

  useEffect(() => {
    const fetchData = async () => {
      const db = firebase.firestore();
      const userPointRef = db.collection("User").doc(userID.uid);
      const puzzleFENRef = await db.collection("chesspuzzleFEN").get();

      userPointRef.get().then(function (doc) {
        if (!doc.exists) {
          userPointRef.set({
            UserName: userID.displayName,
            punkty: [],
          });
        } else {
          userPointRef.onSnapshot(function (doc) {
            setPoint(doc.data());
          });
        }
      });

      setChesspuzzleFEN(
        puzzleFENRef.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      );
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const size = useWindowSize();
  let windowHeight = 0.8 * size.height;
  let rightPanelWidth = size.width - windowHeight - 60;

  useEffect(() => {
    dispatch({ type: "FEN_CHANGED", payload: "" });
    // eslint-disable-next-line
  }, [selectOption]);

  return (
    <>
      <Navbar />
      <div className="row">
        <div id="board" style={{ width: windowHeight }}>
          <SelectFEN
            chesspuzzleFEN={chesspuzzleFEN}
            selectOption={selectOption}
            onFenChange={setSelectOption}
          />
          {chesspuzzleFEN.length > 0 && (
            <Chessboard
              orientation={chesspuzzleFEN[selectOption - 1].orientation}
              transitionDuration={0}
              width={windowHeight}
              dropSquareStyle={{ boxShadow: "inset 0 0 6px 6px #333" }}
              position={
                !moves.length
                  ? chesspuzzleFEN[selectOption - 1].Fen
                  : moves[moves.length - 1]
              }
              getPosition={(position) => {
                dispatch({ type: POSITION_CHANGED, payload: position });
              }}
            />
          )}
        </div>
        <div id="RightPanel" style={{ width: rightPanelWidth }}>
          <span>
            <h1>Welcome {userID.displayName}</h1>
          </span>
          {point.punkty !== undefined && <ScoreBox point={point.punkty} />}
          {chesspuzzleFEN.length > 0 && (
            <MovesBox
              userID={userID.uid}
              taskID={chesspuzzleFEN[selectOption - 1].id}
            />
          )}
        </div>
      </div>
    </>
  );
}
export default MainMenu;
